export interface CatalogBin {
  BinId: number | null;
  BinName: string;
  MaterialId: number | null;
  Enabled: boolean;
  IsActive: boolean;
}
export const CATALOG_BIN_INITIAL_VALUES: CatalogBin = {
  BinId: null,
  BinName: "",
  MaterialId: null,
  Enabled: true,
  IsActive: true,
};
